
import * as ipxRuntime$F7hKNdPzrEjqrzp8Jl8rxbfUCZ4NZ3u0SbZ3fyj7CHc from '/home/galadriel/az-agent/_work/1/s/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as imageProviderRuntime$RXSbQlq3eOoZWEyCyFMNQ1_udptHs62rwjEc0Vcimhs from '/home/galadriel/az-agent/_work/1/s/providers/imageProvider.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imageProvider",
  "domains": [
    "static.plataformatierra.es"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$F7hKNdPzrEjqrzp8Jl8rxbfUCZ4NZ3u0SbZ3fyj7CHc, defaults: {"modifiers":{"format":"webp"}} },
  ['imageProvider']: { provider: imageProviderRuntime$RXSbQlq3eOoZWEyCyFMNQ1_udptHs62rwjEc0Vcimhs, defaults: undefined }
}
        